import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { customerInfoHandler, fetchData, formatDate, formatIndianCurrency, save_demand, saveLogEvent } from '../../utils/Utils';
import Confirmations from '../Confirmation/Confirmations';
import { observer } from 'mobx-react-lite';
import { voiceStore } from '../../stores/voiceStore';

const fn = (dd) => {
    const now = Date.now();
    const dueDateStr = dd;
    const dueDate = new Date(dueDateStr);
    const diffInMilliseconds = dueDate - now;
    const diffInDays = diffInMilliseconds / (1000 * 60 * 60 * 24);
    return diffInDays;
}

const Payment = ({ labels, voiceCommand }) => {
    const { customerNumber, groupNumber, selectedCustomers } = useParams();
    const [customerInfo, setCustomerInfo] = useState({});
    const [thumbnail, setThumbnail] = useState('');
    const [inputValue, setInputValue] = useState(0);
    const [groupInfo, setGroupInfo] = useState();
    const stat = customerInfoHandler(groupInfo);
    const [recommendedValue, setRecommendedValue] = useState(0);
    const [flag, setFlag] = useState(false);
    const [paymentId, setPaymentId] = useState({});
    const [dueDate, setDueDate] = useState('');
    const [isProcessing, setIsProcessing] = useState(false);
    const storedCustomerId = sessionStorage.getItem("SvastiUserID");
    const customerId = JSON.parse(storedCustomerId);
    const [gpNumber, setGpNumber] = useState();
    const [customerThumbnails, setCustomerThumbnails] = useState([]);

    const data = [{
        "customerNumber": customerInfo?.Number,
        "customerName": customerInfo?.Name,
        "emiAmount": inputValue,
        "contactNumber": customerInfo?.Mobile,
        "notificationSentFrom": "Cfa",
        "userId": customerId,
        "typeOfDemand": "CustomerDemand",
        "referenceNumber": (customerInfo?.Number)?.toString(),
        "collectionDemandId": customerInfo?.NextInstalmentDetails?.CollectionDemandId
    }];
    const gpData = [{
        "customerNumber": customerInfo?.Number,
        "customerName": customerInfo?.Name,
        "emiAmount": stat.totalDueAmount,
        "contactNumber": customerInfo?.Mobile,
        "notificationSentFrom": "Cfa",
        "userId": customerInfo?.Number,

        "typeOfDemand": "GroupDemand",

        "referenceNumber": groupNumber || gpNumber?.toString(),

        "breakup": stat.breakup
    }
    ]

    const handleChange = (e) => {
        const newValue = parseInt(e.target.value, 10);
        setInputValue(newValue > recommendedValue ? recommendedValue : newValue);
    };

    const handleClick = () => {
        setIsProcessing(true);
        setFlag(!flag);
        const storedCustomerId = sessionStorage.getItem("SvastiUserID");
        const customerId = JSON.parse(storedCustomerId);

        const logMessage = groupNumber
            ? {
                trigger: "Group Pay dues page On click of button Proceed to pay",
                Page: "PaymentPage - Group Pay dues page",
                groupNumber,
                amount: stat.totalDueAmount
            }
            : {
                trigger: customerNumber === customerId
                    ? "Paying Own Dues - On click of button Proceed to pay"  // ✅ For own dues
                    : "Pay to Other Member dues - On click of button Proceed to pay",  // ✅ For other members
                Page: customerNumber === customerId
                    ? "PaymentPage - Pay Own Dues"  // ✅ Page changes for own dues
                    : "PaymentPage - Pay to Other Member dues",  // ✅ Page remains the same for others
                paidCustomerNumber: customerNumber,
                amount: inputValue
            };


        setTimeout(() => {
            save_demand(groupNumber || selectedCustomers ? gpData : data).then(res => {
                setPaymentId(res);
                setIsProcessing(false);
                saveLogEvent({
                    logLevel: "info",
                    statusCode: 200,
                    status: "success",
                    source: "MCRO",
                    message: {
                        ...logMessage
                    },

                    payload: {
                        demandId: res?.DemandId || "N/A",
                        trigger: logMessage.trigger,
                        Page: logMessage.Page,
                    },
                });
            });
        }, 2000);
    };

    useEffect(() => {
        fetchData()
            .then(data => {
                const selectedCustomerNumbers = selectedCustomers?.split(',');
                const filteredCustomers = data?.data?.GroupDetails?.Customers.filter(
                    customer => selectedCustomerNumbers?.includes(customer.Number.toString())
                );

                if (selectedCustomers) {
                    setGroupInfo({
                        ...data?.data,
                        GroupDetails: {
                            ...data?.data?.GroupDetails,
                            Customers: filteredCustomers
                        }
                    });
                    setCustomerThumbnails(filteredCustomers.map(customer => ({
                        thumbnail: customer.Thumbnail,
                        number: customer.Number
                    })));
                } else {
                    setGroupInfo(data?.data);
                    setCustomerThumbnails(data?.data?.GroupDetails?.Customers?.map(customer => ({
                        thumbnail: customer.Thumbnail,
                        number: customer.Number
                    })));
                }

                setGpNumber(data?.data?.GroupDetails?.Number)

                const customer = data?.data?.GroupDetails?.Customers.find(el => el.Number == customerNumber);
                if (customer) {
                    setCustomerInfo(customer);
                    setDueDate(customer?.NextInstalmentDetails?.DueDate);
                    setThumbnail(customer?.Thumbnail);
                    if (customer.LoanHealth === "Overdue") {
                        setInputValue(customer?.OverdueAmount || 0);
                        setRecommendedValue(customer?.OverdueAmount || 0);
                    } else {
                        setInputValue(customer?.NextInstalmentDetails?.AmountDue || 0);
                        setRecommendedValue(customer?.NextInstalmentDetails?.AmountDue || 0);
                    }
                }
            })
            .catch(error => {
                console.error('Error:', error);
            });

    }, [customerNumber]);

    useEffect(() => {
        if (groupNumber || selectedCustomers && stat.totalDueAmount > 0) {
            voiceStore.setVoiceCommand(`You should make a payment of ${stat.totalDueAmount} Rupees`)
        }
    }, [voiceCommand, stat.totalDueAmount, groupNumber]);

    const paymentRequest = () => {
        const paymentFlag = fn(dueDate) && fn(dueDate) > 3 && customerInfo?.LoanHealth !== "Overdue";
        if (paymentFlag) {
            voiceStore.setVoiceCommand(`${labels.instalmentWarning}`)
        }
        if (groupNumber || selectedCustomers) {
            return <>
                <div className="font-bold mt-2 text-black text-lg border-t border-r border-l bg-gray-300 p-3 rounded-t-lg fs-32w">{labels.PayForAWholeGroup} {stat.groupName}</div>
                <div className="p-4 rounded-tl-none rounded-tr-none rounded-b-lg border-2 border-gray-300 fs-30w">
                    <div className="flex justify-around space-x-2 mb-4 overflow-x-auto max-w-[100%] w-fit mx-auto no-scrollbar">
                        {customerThumbnails?.map((customer, index) => (
                            <div key={index} className="flex flex-col items-center">
                                <div className="w-16 h-16 rounded-full overflow-hidden border-2 border-green-500 flex-shrink-0">
                                    <img src={customer.thumbnail} alt="Customer" className="w-full h-full object-cover" />
                                </div>
                                <span className="text-xs mt-1 text-center">{customer.number}</span>
                            </div>
                        ))}
                    </div>


                    <div className="grid grid-cols-2 gap-2">
                        <div>{labels.GroupName}</div>
                        <div className="justify-self-end">{stat.groupName}</div>
                        <div>{labels.GroupId}</div>
                        <div className="justify-self-end">{stat.groupNumber}</div>
                        <div>{labels.paymentType}</div>
                        <div className="justify-self-end">Installment</div>
                        <div>{labels.dueDate}</div>
                        <div className="justify-self-end">{formatDate(stat.dueDate)}</div>
                        <div>{labels.amountDue}</div>
                        <div className="justify-self-end">{formatIndianCurrency(stat.totalDueAmount)}</div>
                    </div>
                    {!paymentFlag && <div className="grid grid-cols-2 gap-2">
                        <div>{labels.wantToPay}</div>
                        <div className="justify-self-end text-lg text-[black]">
                            <input
                                type="number"
                                value={stat.totalDueAmount}
                                onChange={handleChange}
                                min={1}
                                max={stat.totalDueAmount}
                                step="1"
                                className='rounded-md text-center border-2 border-gray-300'
                                disabled
                            />
                        </div>
                    </div>}
                    <div className="flex justify-center">
                        <button className={`mt-4 text-black px-4 py-2 rounded-lg ${isNaN(stat.totalDueAmount) || stat.totalDueAmount <= 0 || stat.totalDueAmount === '' || paymentFlag ? "pointer-events-none opacity-50" : ""}`} style={{ backgroundColor: "#fdba14" }} onClick={handleClick}>
                            {labels.proceedToPay}
                        </button>
                    </div>
                </div>
                {paymentFlag && <div className='mx-auto mt-4 text-center text-red-500 fs-30w'>{labels.instalmentWarning}</div>}
                {inputValue < recommendedValue && <div className='mx-auto mt-4 text-center text-red-500 fs-30w'>{labels.lessAmountWarning}</div>}
            </>
        }
        else {

            return <>
                <div className="font-bold mt-2 text-black text-lg border-t border-r border-l bg-gray-300 p-3 rounded-t-lg fs-32w">{labels.paymentFor} {customerInfo?.Name}</div>
                <div className="p-4 rounded-tl-none rounded-tr-none rounded-b-lg border-2 border-gray-300 fs-30w">
                    <div className="grid grid-cols-2 gap-2">
                        <div>{labels.customerNumber}</div>
                        <div className="justify-self-end">{customerInfo?.Number}</div>
                        <div>{labels.paymentType}</div>
                        <div className="justify-self-end">{customerInfo?.LoanHealth === "Overdue" ? "Overdue" : "Installment"}</div>
                        <div>{labels.dueDate}</div>
                        <div className="justify-self-end">{formatDate(dueDate)}</div>
                        <div>{labels.amountDue}</div>
                        <div className="justify-self-end">{formatIndianCurrency(recommendedValue)}</div>
                    </div>
                    <div className="flex justify-center my-6">
                        <div className="w-[150px] h-[150px] bg-gray-300 overflow-hidden">
                            <img src={thumbnail} alt={thumbnail} className="w-full h-full object-cover" />
                        </div>
                    </div>
                    {!paymentFlag && <div className="grid grid-cols-2 gap-2">
                        <div>{labels.wantToPay}</div>
                        <div className="justify-self-end text-lg text-[black]">
                            <input
                                type="number"
                                value={inputValue}
                                onChange={handleChange}
                                min={1}
                                max={recommendedValue}
                                step="1"
                                className='rounded-md text-center border-2 border-gray-300'
                                disabled
                            />
                        </div>
                    </div>}
                    <div className="flex justify-center">
                        <button className={`mt-4 text-black px-4 py-2 rounded-lg ${isNaN(inputValue) || inputValue <= 0 || inputValue === '' || paymentFlag ? "pointer-events-none opacity-50" : ""}`} style={{ backgroundColor: "#fdba14" }} onClick={handleClick}>
                            {labels.proceedToPay}
                        </button>
                    </div>
                </div>
                {paymentFlag && <div className='mx-auto mt-4 text-center text-red-500 fs-30w'>{labels.instalmentWarning}</div>}
                {inputValue < recommendedValue && <div className='mx-auto mt-4 text-center text-red-500 fs-30w'>{labels.lessAmountWarning}</div>}
            </>
        }
    }
    if (isProcessing) {
        return (
            <div className="p-4 mt-[30%] border-2 border-gray-300 rounded-lg text-center">
                <div className="text-lg font-bold">{labels.processing}</div>
                <div>{labels.pleaseWait}</div>
            </div>
        );
    }

    return (
        <>
            {
                (flag ? <Confirmations gpName={stat.groupName} gpNumber={stat.groupNumber} totalAmount={stat.totalDueAmount} customerInfo={customerInfo} inputValue={inputValue} paymentId={paymentId} thumbnail={thumbnail} labels={labels} customerThumbnails={customerThumbnails} /> : paymentRequest())
            }
        </>
    );
}

export default observer(Payment);
